/**
 * Overlap Servces.
 * @format
 */
import { currentlyLoggedIn } from './drupal-services';

/**
 * Setup Overlaps.
 */
export const setupOverlaps = (): void => {
  /**
   * Get Initial Spacing.
   */
  const getInitialSpacing = (element: HTMLElement): string => {
    const elementStyles = window.getComputedStyle(element);
    const initialPaddingTop = elementStyles.getPropertyValue('padding-top');
    return initialPaddingTop.replace('px', '');
  };

  /**
   * Adjust Sibling Paragraph Spacing.
   * Add the appropriate spacer offset to either the previous or next sibiling
   * paragraph.
   *
   * @param {Element | null | undefined} siblingParagraph
   * @param {string} location
   */
  const adjustSiblingParagraphSpacing = (
    siblingParagraph: Element | null | undefined,
    location: string
  ): void => {
    const isLoggedIn = currentlyLoggedIn();
    if (siblingParagraph) {
      const childParagraph: HTMLElement | null =
        siblingParagraph.querySelector('.paragraph');

      /**
       * Check if sibling element is another banner.  Used for adjusting
       * spacing for when the overlap banner is next to a countdown banner.
       */
      if (childParagraph?.classList.contains('varian-banner-wrapper')) {
        const countdownBanner = childParagraph.querySelector(
          '.countdown-banner .text-container'
        );
        if (countdownBanner) {
          countdownBanner.classList.add('adjust-banner-overlap');
        }
      } else if (childParagraph) {
        const initialSpacing = getInitialSpacing(childParagraph);
        const spacerClass =
          location === 'banner'
            ? 'banner-spacer'
            : `${location}-spacer-${initialSpacing}`;
        childParagraph.classList.add(spacerClass);
      }
    } else {
      if (isLoggedIn) {
        console.warn(
          `Overlap boundary reached. Cannot add a ${location} overlap spacer.`
        );
      }
    }
  };

  /**
   * Add Bottom Spacer.
   */
  const addSpacer = (overlap: HTMLElement, location: string): void => {
    const overlappingParagraph: Element | null = overlap.parentElement;

    if (overlappingParagraph) {
      const fieldItem = overlappingParagraph.closest('section.blade');
      fieldItem?.classList.add('zindex-1', 'position-relative');
      const bottomSibling = fieldItem?.previousElementSibling;
      const topSibling = fieldItem?.nextElementSibling;

      if (location === 'top') {
        adjustSiblingParagraphSpacing(bottomSibling, 'bottom');
      } else if (location === 'bottom') {
        adjustSiblingParagraphSpacing(topSibling, 'top');
      } else if (location === 'both') {
        adjustSiblingParagraphSpacing(topSibling, 'top');
        adjustSiblingParagraphSpacing(bottomSibling, 'bottom');
      } else if (location === 'banner') {
        adjustSiblingParagraphSpacing(topSibling, 'banner');
      }
    }
  };

  /**
   * Overlap Check.
   */
  const overlapCheck = (): void => {
    const overlappingParagraphs: NodeListOf<HTMLElement> =
      document.querySelectorAll(
        '.has-overlap-bottom, .has-overlap-top, .has-overlap-both'
      );

    if (overlappingParagraphs.length > 0) {
      [].forEach.call(overlappingParagraphs, (paragraph: HTMLElement): void => {
        /**
         * Skip banner overlap.
         */
        if (paragraph.classList.contains('varian-banner-container')) {
          addSpacer(paragraph, 'banner');
        } else {
          if (
            paragraph.className.indexOf('top-spacer-') === -1 &&
            paragraph.className.indexOf('bottom-spacer-') === -1 &&
            paragraph.className.indexOf('vertical-spacer-')
          ) {
            if (paragraph.className.indexOf('has-overlap-top') > -1) {
              addSpacer(paragraph, 'top');
            } else if (paragraph.className.indexOf('has-overlap-bottom') > -1) {
              addSpacer(paragraph, 'bottom');
            } else if (paragraph.className.indexOf('has-overlap-both') > -1) {
              addSpacer(paragraph, 'both');
            }
          }
        }
      });
    }
  };
  overlapCheck();
};
